export function _resolvePatientJourneyListColumnOfType_walkingStepsSummary(column, patientJourney, row) {
    const walkingStepsSummary = row[column.id]?.value

    column.setExplicitValueConfig(walkingStepsSummary)
}